export type MallConfig = {
  id: number;
  title: string;
  publicUrl: string;
};

const MALLS: Record<string, MallConfig> = {
  'bilegmah.com':     { id: 1, title: 'БИЛЭГ МАХНЫ ДЭЛГҮҮР',     publicUrl: '/mall1' },
  'hishigmah.com':    { id: 2, title: 'ЭРҮҮЛ ХҮНС ХИШИГ МАХ',    publicUrl: '/mall2' },
  'halalet.com':      { id: 3, title: 'HALAL SHOPPING IN KOREA', publicUrl: '/mall3' },
  'nuudelchin.co.kr': { id: 4, title: 'nuudelchin',              publicUrl: '/mall1' },
};

const FALLBACK: MallConfig = MALLS['bilegmah.com'];

export function getMallConfig(): MallConfig {
  if (typeof window === 'undefined') return FALLBACK;
  const host = window.location.hostname.replace(/^www\./, '');
  return MALLS[host] ?? FALLBACK;
}

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.bilegmah.com';
